/* eslint-disable */
export const START_LOAD_MEDALS = 'START_LOAD_MEDALS';
export const ERROR_LOAD_MEDALS = 'ERROR_LOAD_MEDALS';
export const FINISH_LOAD_MEDALS = 'FINISH_LOAD_MEDALS';



// WEBPACK FOOTER //
// ./src/models/medals/constants.js